import { userType, userPrivilege } from "const/nuclias/user";
import { organizationType } from "const/nuclias/organization";

export const pathList = [
  { label: 'f4f70727dc', isLink: false },
  { label: 'a6e7cd29c1', isLink: false },
  { label: '9571c08438', isLink: false },
];

export const tableColumn = {
  metadataSet: [
    { label: '49ee308734', accessor: 'name', sortable: true },
    { label: '8c4d3f3908', accessor: 'url', sortable: true },
    { label: '62ed2c4660', accessor: 'issuer', sortable: true },
    { label: '0175d1985e', accessor: 'certificate', sortable: true },
    { label: 'dd3f69657c', accessor: 'logouturl', sortable: true },
    { label: '34e6045742', accessor: 'fingerprint', sortable: true }
  ],
  samlRole: {
    [organizationType.si]: [
      { label: '49ee308734', accessor: 'name', sortable: true },
      { label: '727b677950', accessor: 'role', sortable: true },
      { label: '8daa157a06', accessor: 'managedScopeLength', sortable: true },
    ],
    [organizationType.org]: [
      { label: '49ee308734', accessor: 'name', sortable: true },
      { label: '727b677950', accessor: 'role', sortable: true },
      { label: '6821f4bbf3', accessor: 'managedScopeLength', sortable: true },
    ],
  }
};

export const defaultAccessRoleList = [
  { id: 0, title: 'e3afed0047', value: userPrivilege.manager, isActive: false },
  { id: 1, title: '344a7f427f', value: userPrivilege.editor, isActive: false },
  { id: 2, title: '6ba872551f', value: userPrivilege.monitor, isActive: false },
  { id: 3, title: 'fb15c53f22', value: userPrivilege.viewer, isActive: false },
];

export const defaultAccessLevelTypeList = [
  { id: 1, title: '4b65444060', value: userType.si, isActive: false },
  { id: 2, title: 'c1ca926603', value: userType.org, isActive: false },
  { id: 3, title: '3039a00fca', value: userType.siteTag, isActive: false },
  { id: 4, title: 'a7d6475ec8', value: userType.site, isActive: false },
];

// Modal
export const metadataSetField = {
  name: 'name',
  byManualOrImport: 'byManualOrImport',
  url: 'url',
  issuer: 'issuer',
  certificate: 'certificate',
  logoutUrl: 'logoutUrl',
  fingerprint: 'fingerprint',
  metadataSetXml: 'metadataSetXml'
};

export const defaultMetadataSetState = {
  [metadataSetField['name']]: {
    byManualOrImport: true,
    type: String,
    apiKey: 'name',
    value: '',
    dirty: false,
    valid: false
  },
  [metadataSetField['byManualOrImport']]: {
    value: true
  },
  [metadataSetField['url']]: {
    byManualOrImport: true,
    type: String,
    apiKey: 'loginUrl',
    value: '',
    required: false,
    dirty: false,
    valid: true
  },
  [metadataSetField['issuer']]: {
    byManualOrImport: true,
    type: String,
    apiKey: 'issuer',
    value: '',
    required: false,
    dirty: false,
    valid: true
  },
  [metadataSetField['certificate']]: {
    byManualOrImport: true,
    type: Object,
    apiKey: {
      idpCertFile: 'idpCertFile',
      idpCertFileName: 'idpCertFileName'
    },
    value: null,
    file: null,
    required: true,
    dirty: false,
    valid: false
  },
  [metadataSetField['logoutUrl']]: {
    byManualOrImport: true,
    type: String,
    apiKey: 'logoutUrl',
    value: '',
    required: false,
    dirty: false,
    valid: true
  },
  [metadataSetField['fingerprint']]: {
    byManualOrImport: true,
    type: String,
    apiKey: 'idpCertFingerprint',
    value: '',
    required: false,
    dirty: false,
    valid: true
  },
  [metadataSetField['metadataSetXml']]: {
    byManualOrImport: false,
    type: Object,
    apiKey: {
      idpMetaDataXmlFile: 'idpMetaDataXmlFile',
      idpMetaDataXmlFileName: 'idpMetaDataXmlFileName'
    },
    value: '',
    file: null,
    required: true,
    dirty: false,
    valid: false
  }
};

// Model
export const defaultSelectedItem = { id: 0, isAll: true, title: 'b1c94ca2fb', isActive: false, checked: false };
export const defaultSelectedAllSitesItem = { id: 0, title: '299287797e', isActive: false };
export const defaultAccessPrivilege = { type: '', typeLabel: '' };
export const defaultAccessLevel = { type: '', typeLabel: '', owner: '' };
export const defaultManagedList = { siList: [], siteList: [] };

export const defaultSamlRoleState = {
  name: {
    value: '',
    dirty: false,
    valid: false
  },
  accessPrivilegeRole: {
    list: [],
    selected: {},
    disabled: false,
    valid: true
  },
  accessPrivilegeLevelType: {
    list: [],
    selected: {},
    disabled: false,
    valid: true
  },
  accessPrivilegeLevelOrg: {
    list: [],
    selected: {},
    disabled: false,
    valid: true
  },
  managedOrganization: {
    list: [],
    selected: {},
    disabled: false,
    valid: true
  },
  managedSiteTag: {
    list: [],
    selected: {},
    disabled: false,
    valid: true
  },
  managedSite: {
    list: [],
    originList: [],
    selected: {},
    disabled: false,
    valid: true
  },
};